import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import {provide, ref} from "vue";


const __default__ = {
    name: "CabinetIframeWrapper"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

provide(isInSelectedSectionInjectionKey, ref(true));

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})